var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2498 2.99959C8.15978 2.85959 3.98978 6.93959 3.98978 11.9996H2.19978C1.74978 11.9996 1.52978 12.5396 1.84978 12.8496L4.63978 15.6496C4.83978 15.8496 5.14978 15.8496 5.34978 15.6496L8.13978 12.8496C8.45978 12.5396 8.22978 11.9996 7.78978 11.9996H5.98978C5.98978 8.09959 9.16978 4.94959 13.0898 4.99959C16.8098 5.04959 19.9398 8.17959 19.9898 11.8996C20.0398 15.8096 16.8898 18.9996 12.9898 18.9996C11.3798 18.9996 9.88978 18.4496 8.70978 17.5196C8.30978 17.2096 7.74978 17.2396 7.38978 17.5996C6.96978 18.0296 6.99978 18.7296 7.46978 19.0996C8.98978 20.2896 10.9098 20.9996 12.9898 20.9996C18.0398 20.9996 22.1298 16.8296 21.9898 11.7396C21.8598 7.04959 17.9398 3.12959 13.2498 2.99959ZM12.7398 7.99959C12.3298 7.99959 11.9898 8.33959 11.9898 8.74959V12.4296C11.9898 12.7796 12.1798 13.1096 12.4798 13.2896L15.5998 15.1396C15.9598 15.3496 16.4198 15.2296 16.6298 14.8796C16.8398 14.5196 16.7198 14.0596 16.3698 13.8496L13.4898 12.1396V8.73959C13.4898 8.33959 13.1598 7.99959 12.7398 7.99959Z",
    fill: "#001B53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFeedIcon);
export default __webpack_public_path__ + "static/media/activityFeedIcon.6906edd1561aa89e70d2c1868489414d.svg";
export { ForwardRef as ReactComponent };